import { getDevicePassword } from "@/composables/auth";
import { getUserInfo, getAbcToken, getSignatureInfo } from "@/composables/auth";
import { clearLocalStorage } from "@/composables/localStorage";
import { useUserStore } from "@/stores/user";

export async function auth(to: any, from: any, next: any) {
    const userInfo = getUserInfo();
    const abcToken = await getAbcToken();
    const devicePassword = await getDevicePassword();
    const signatureInfo = await getSignatureInfo();

    // 루트 경로 처리 추가
    if (to.path === '/') {
        if (import.meta.env.MODE === 'production') {
            return next('/style');
        } else {
            return next('/main');
        }
    }

    if (to.path.includes('sign_up')) {
        if (userInfo) {
            await useUserStore().getMe();
            return next();
        } else {
            return next('/');
        }
    } else if (
        userInfo && abcToken && devicePassword && signatureInfo &&
        userInfo?.exp && new Date(userInfo.exp).getTime() > (new Date().getTime() / 1000)
    ) {
        await useUserStore().getMe();
    } else {
        clearLocalStorage();
    }
    return next();
}

export function needAuth(to: any, from: any, next: any) {
    if (to.path.includes('my_page') || to.path.includes('style/upload')) {
        const me = useUserStore().me;
        if (!me) {
            return next('/login');
        }
    }
    return next();
}

export function checkProduction(to: any, from: any, next: any) {
    if (import.meta.env.MODE === 'production') {
        // /main 경로도 /style로 리다이렉트
        if (to.path === '/main' || (!to.path.includes('style') && !to.path.includes('login') && !to.path.includes('sign_up'))) {
            return next('/style');
        }
    }

    return next();
}